import { parseTankQrPayload } from "./qrPayload";
import type { HallPatrolTankSnapshot } from "./hallPatrol";

export type LocalTankResolution =
  | { kind: "resolved"; tank: HallPatrolTankSnapshot }
  | { kind: "invalid_qr" }
  | { kind: "not_found"; tankCode: string }
  | { kind: "ambiguous"; tankCode: string };

export function resolveTankQrLocally(
  rawPayload: string,
  localTanks: readonly HallPatrolTankSnapshot[],
): LocalTankResolution {
  const parsed = parseTankQrPayload(rawPayload);

  if (parsed.kind !== "valid") {
    return { kind: "invalid_qr" };
  }

  const matches = localTanks.filter((tank) => tank.tankCode === parsed.tankCode);

  if (matches.length === 0) {
    return { kind: "not_found", tankCode: parsed.tankCode };
  }

  if (matches.length > 1) {
    return { kind: "ambiguous", tankCode: parsed.tankCode };
  }

  const tank = matches[0];

  if (!tank) {
    return { kind: "not_found", tankCode: parsed.tankCode };
  }

  return { kind: "resolved", tank };
}
